module.exports = __webpack_public_path__ + "static/media/Icon-1.91147906.svg";